<template>
  <main class="mt-5">
    <span id="add-btn">
      <router-link :to="'/admin/Contradictions/create'" class="btn btn-success">
        ثبت
      </router-link>
    </span>
    <b-tooltip
      v-if="!hasPermission('write_store')"
      target="add-btn"
      triggers="hover"
    >
      شما به این بخش دسترسی ندارید
    </b-tooltip>
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold">مغایرت گیری</h5>
        <div style="flex:1"></div>
      </div>
      <div class="card-body">
        <div>
          <b-table
            responsive
            hover
            bordered
            :items="items.data"
            :fields="fields"
          >
            <template v-slot:cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template v-slot:cell(created_at)="data">
              {{ data.item.created_at | persianDate }}
            </template>
            <template v-slot:cell(show)="data">
              <router-link
                :to="'/admin/Contradictions/show/' + data.item.id"
                class="action-btns1 pt-1 px-1"
              >
                <i
                  style="vertical-align: text-top"
                  class="fe fe-eye text-primary"
                ></i>
              </router-link>
            </template>
          </b-table>
          <Loading v-if="$root.isEmptyObject(items)" />
          <pagination
            v-else-if="items.data != ''"
            :disabled="disabled"
            :limit="2"
            :data="items"
            @pagination-change-page="changePage"
          >
          </pagination>
          <div v-if="$root.isEmptyObject(items)" class="alert alert-danger">
            موردی یافت نشد
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import ContradictionsImpl from "@@/core/pages/Contradictions/contradictionsImpl";
export default {
  extends: ContradictionsImpl,
};
</script>
